

























import {
  ModalMixin, Modal, AsyncBtn, notify,
} from 'mycorems-app-shared';
import _ from 'lodash';
import { PricePlan, ModalElement } from '@/types';
import MoneyInput from '@/components/MoneyInput.vue';
import { add, edit } from './price-plan-service';

interface LocalPricePlan {
  numReports: number|null,
  amount: number|null,
}

interface Data {
  task: Promise<PricePlan>|Promise<void>|null,
  localPricePlan: LocalPricePlan|PricePlan,
}

export default ModalMixin.extend({
  props: {
    pricePlan: Object as () => PricePlan,
    mode: {
      type: String,
      default: 'Add',
    },
  },
  data(): Data {
    return {
      task: null,
      localPricePlan: (this.pricePlan) ? _.cloneDeep(this.pricePlan) : {
        numReports: null,
        amount: null,
      },
    };
  },
  computed: {
    canSave(): boolean {
      return (
        this.localPricePlan.numReports !== null && this.localPricePlan.amount !== null
      );
    },
  },
  methods: {
    save(): void {
      if (this.pricePlan) {
        this.edit();
      } else {
        this.add();
      }
    },
    add() {
      if (this.localPricePlan.numReports && this.localPricePlan.amount) {
        this.task = add(this.localPricePlan.numReports, this.localPricePlan.amount, null, null);
        this.task.then((pricePlan: PricePlan) => {
          this.$emit('ok', pricePlan);
          (this.$refs.modal as ModalElement).hide();
          notify.success('Price plan added.');
        });
      }
    },
    edit() {
      if (this.localPricePlan.numReports && this.localPricePlan.amount) {
        this.task = edit(
          this.pricePlan.id, this.localPricePlan.numReports,
          this.localPricePlan.amount, null, null,
        );
        this.task.then(() => {
          this.$emit('ok', this.localPricePlan);
          (this.$refs.modal as ModalElement).hide();
          notify.success('Price plan updated.');
        });
      }
    },
  },
  components: {
    modal: Modal,
    'money-input': MoneyInput,
    'async-btn': AsyncBtn,
  },
});
